import classnames from 'classnames';
import './style.scss';

const ModalFooter = (props) => {    
    const {
        saveButtonText,
        saveButtonClass,
        onConfirm,
        onCancel,
        cancelButtonText
    } = props;
    const classButton = saveButtonClass ? saveButtonClass : 'btn-bg-cs-1';
    
    return (
        <div className={classnames('modal-footer')}>
            {cancelButtonText && (
                <button
                    type='button'
                    className='btn btn-cs-3 cancel-button'
                    data-dismiss='modal'
                    onClick={onCancel}
                >
                    {cancelButtonText}
                </button>
            )}
            <button
                type='button'
                className={`btn ${classButton}`}
                onClick={onConfirm}
            >
                {saveButtonText}
            </button>
        </div>
    );
};

export default ModalFooter;
